import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-upload-exam-os',
    templateUrl: './upload-exam-os.component.html',
    styleUrls: ['./upload-exam-os.component.scss']
})
export class UploadExamOSComponent implements OnInit {

    sender = "upload-exam-os";
    fileType: any = "image/jpg,image/jpeg,image/png";
    error: any;

    constructor(
        private router: Router,
    ) { }

    ngOnInit() { }

    onExamOSUpload(e) {
        // this.documentId = e.documentid;
    };

    ondocError(e) {
        this.error = e;
    }


}
